<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="90px">
        <el-col :span="12">
          <el-form-item :label="$t('manage.name27')" prop="roleName">
            <el-input v-model="queryInfo.roleName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;" @change="getSysRoleList">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" v-if="buttonPerms.indexOf('sysrole/list') > -1" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="restQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addRole(1)" v-if="buttonPerms.indexOf('sysrole/save') > -1">{{ $t('manage.name30') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="loading">
      <el-table-column label="id" prop="roleId" sortable width="120"></el-table-column>
      <el-table-column :label="$t('manage.name28')" prop="roleName" width="180" sortable></el-table-column>
      <el-table-column :label="$t('manage.name29')" prop="menusName" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.roleId === 1">{{ $t('manage.name106') }}</div>
          <div v-else class="menuname">
            <div v-for="(item, index) in lang === 'zh' ? scope.row.menusName.split(',') : scope.row.emenusName.split(',')" :key="index" class="item-menuname">
              <span>{{ item }}</span>
              <span v-if="index < scope.row.menusName.split(',').length - 1">，</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addRole(2, scope.row)" v-if="scope.row.roleId > 1 && buttonPerms.indexOf('sysrole/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" style="color:#ea4646" v-if="scope.row.roleId > 1 && buttonPerms.indexOf('sysrole/delete') > -1">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="type === 1 ? $t('manage.name31') : $t('manage.name96')" v-if="roleInfoDialog" :visible.sync="roleInfoDialog" :close-on-click-modal ="false" :before-close="close" width="500px">
      <el-form ref="userFormRef" :model="roleInfo" :rules="roleInfoRules" label-width="110px" class="role-info">
        <el-form-item prop="roleName" :label="$t('manage.name32')">
          <el-input v-model="roleInfo.roleName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="status" :label="$t('manage.name33')">
          <el-radio v-model="roleInfo.status" label="1">{{ $t('manage.name34') }}</el-radio>
          <el-radio v-model="roleInfo.status" label="0">{{ $t('manage.name35') }}</el-radio>
        </el-form-item>
        <el-form-item prop="name" :label="$t('manage.name36')">
          <el-tree :data="treeData" show-checkbox node-key="menuId" :default-expand-all="true" :default-checked-keys="checkedKeys" :props="defaultProps" @check="chechChange">
            <template slot-scope="{ data }">
              <span v-if="lang === 'zh'">{{ data.menuName }}</span>
              <span v-else>{{ data.emenuName }}</span>
            </template>
          </el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('manage.name16')" v-if="bindingRolesDialog" :visible.sync="bindingRolesDialog" :close-on-click-modal ="false" :before-close="close" width="400px">
      <el-form ref="rolesFormRef" :model="rolesInfo" label-width="120px">
        <el-form-item prop="content" :label="$t('manage.name25')">
          <el-select v-model="rolesInfo.roles" :placeholder="$t('public.name1')">
            <el-option v-for="item in rolesOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSysroleSave" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button type="primary" @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { sysroleList, sysmenutemplateList, sysroleSave, sysroleUpdate, sysroleDelete } from '@/api/manage.js'
export default {
  data() {
    return {
      loginstatus: 1,
      queryInfo: {
        roleName: '',
        status: 2,
        page: 1,
        limit: 10
      },
      tableList: [],
      statusList: [
        {
          value: 2,
          label: this.$t('public.name19')
        },
        {
          value: 1,
          label: this.$t('public.name20')
        },
        {
          value: 0,
          label: this.$t('public.name21')
        }
      ],
      total: 0,
      selectList: [],
      roleInfoRules: {
        roleName: [
          {
            required: true,
            message: this.$t('screen.name19'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: this.$t('screen.name20'),
            trigger: 'blur'
          }
        ]
      },
      roleInfo: {
        status: '1',
        roleName: '',
        id: ''
      },
      showMsgVisible: false,
      rolesInfo: {
        roles: ''
      },
      showMsgallVisible: false,
      roleInfoDialog: false,
      bindingRolesDialog: false,
      rolesOptions: [
        { label: this.$t('screen.name21'), value: '1' },
        { label: this.$t('screen.name22'), value: '2' }
      ],
      loading: false,
      treeData: [],
      defaultProps: {
        children: 'childList',
        label: 'menuName'
      },
      type: 1,
      checkedKeys: [],
      halfCheckedKeys: [],
      buttonPerms: '',
      lang: ''
    }
  },
  created() {
    this.lang = localStorage.getItem('lang') || 'zh'
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getSysRoleList()
  },
  methods: {
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.getSysRoleList()
    },
    getSysRoleList() {
      this.loading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 0
      }

      if (this.queryInfo.roleName) {
        data.roleName = this.queryInfo.roleName.trim()
      }

      if (this.queryInfo.status !== 2) {
        if (this.queryInfo.status === 1) {
          data.status = true
        } else {
          data.status = false
        }
      }

      sysroleList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.loading = false
        })
    },

    restQueryInfo() {
      this.queryInfo = {
        roleName: '',
        status: 2,
        page: 1,
        limit: 10
      }
      this.getSysRoleList()
    },

    chechChange(data1, data2) {
      this.checkedKeys = []
      data2.checkedKeys.map(item => {
        this.checkedKeys.push(item)
      })

      this.halfCheckedKeys = []
      data2.halfCheckedKeys.map(item => {
        this.halfCheckedKeys.push(item)
      })
    },

    addRole(type, row) {
      this.type = type
      this.checkedKeys = []
      this.roleInfoDialog = true
      if (type === 2) {
        this.roleInfo.status = row.status ? '1' : '0'
        this.roleInfo.roleName = row.roleName
        this.roleInfo.id = row.roleId
        this.checkedKeys = row.menusId.split(',')
      }
      this.getSysMenuTree()
    },

    delUser(row) {
      this.$confirm(this.$t('screen.name23'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          sysroleDelete({
            id: row.roleId
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.getSysRoleList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },

    getSysMenuTree() {
      const data = {
        tenantType: 0
      }

      sysmenutemplateList(data)
        .then(res => {
          this.treeData = res.data
        })
        .catch(() => {})
    },
    close() {
      this.roleInfoDialog = false
      this.roleInfo = {
        status: '1',
        roleName: ''
      }
      this.bindingRolesDialog = false
    },
    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return

        this.loading = true

        let status = true

        if (this.roleInfo.status === '1') {
          status = true
        } else {
          status = false
        }

        if (this.type === 1) {
          const data = {
            roleName: this.roleInfo.roleName,
            rules: this.checkedKeys.join(','),
            rulesBak: this.halfCheckedKeys.join(','),
            status: status
          }
          sysroleSave(data)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.queryInfo.page = 1
                this.close()
                this.getSysRoleList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          const data = {
            id: this.roleInfo.id,
            roleName: this.roleInfo.roleName,
            rules: this.checkedKeys.join(','),
            rulesBak: this.halfCheckedKeys.join(','),
            status: status
          }
          sysroleUpdate(data)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.queryInfo.page = 1
                this.close()
                this.getSysRoleList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    bindingRoles(row) {
      this.bindingRolesDialog = true
    },

    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getSysRoleList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getSysRoleList()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .menuname {
    display: flex;
    flex-wrap: wrap;
    .item-menuname {
    }
  }

  .role-info {
    height: 55vh;
    width: 460px;
    overflow: auto;
  }
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
.map {
  width: 100%;
  height: 800px;
}
</style>
